import { Contact } from "Pages";
import { Email } from "@mui/icons-material";

const ContactContent = {
  title: "Contact",
  message:
    "Thanks for stopping by! Please feel free to reach out about lessons, performances, or any other questions you may have.",
  sendToEmail: process.env.REACT_APP_EMAIL,
  icon: <Email />,
  path: "/contact",
  menu: true,
  menuIndex: 3,
  element: <Contact />,
};

export default ContactContent;
